export const redeemHistoryState = () => ({
  startDate: null,
  endDate: null,
  page: 1,
  perPage: 10,
  searchKey: "",
  referenceStation: {
    value: [],
    isSelectedAll: true,
  },
});
